import { FormInput, FormSelect } from '@systemeio/ui';
import { ErrorResponseContentInterface } from '@systemeio/util';
import { WiseRecipientFormFieldTypesEnum } from 'modules/profile/affiliate-settings/enums/wise-recipient-form-field-types-enum';
import { useWiseRecipientApi } from 'modules/profile/affiliate-settings/hooks/use-wise-recipient-api';
import { WiseRecipientApiInterface } from 'modules/profile/affiliate-settings/types/affiliate-settings-interface';
import { WiseRecipientDetailsFieldInterface, WiseRecipientDetailsInterface, WiseRecipientDetailsItemInterface } from 'modules/profile/affiliate-settings/types/wise-details-interface';
import { useEffect, useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface AdditionalFormFieldsProps {
  formData: WiseRecipientDetailsInterface | null;
  setFormData: React.Dispatch<React.SetStateAction<WiseRecipientDetailsInterface | null>>;
  state: WiseRecipientApiInterface;
  onChangeDetails: (key: string, value: string) => void;
  fieldErrors: ErrorResponseContentInterface['fields'];
  onChangeRecipientDetailsType: (value: string) => void;
  resetFormErrors: () => void;
  updateFormDetails: (details: Record<string, string>) => void;
}
export function AdditionalFormFields({
  formData,
  setFormData,
  onChangeDetails,
  state,
  fieldErrors,
  onChangeRecipientDetailsType,
  resetFormErrors,
  updateFormDetails
}: AdditionalFormFieldsProps) {
  const {
    t
  } = useLocoTranslation();
  const isTypeOfRecipientDetailsSelect = !!formData;
  const [activeForm, setActiveForm] = useState<WiseRecipientDetailsItemInterface | undefined>();
  const [isActiveFormFetching, setIsActiveFormFetching] = useState(false);
  const typeOfRecipientDetailsSelectData = isTypeOfRecipientDetailsSelect && formData ? Object.values(formData).map(item => ({
    id: item?.type || '',
    caption: item?.title || ''
  })) : [];
  const {
    getCurrentWiseRecipientDetails
  } = useWiseRecipientApi();
  const handleFormSelectChange = async (field: WiseRecipientDetailsFieldInterface, data: string) => {
    resetFormErrors();
    const fieldKey = field.group?.[0]?.key;
    if (!fieldKey) return;
    onChangeDetails(fieldKey, data);
    if (field.group[0]?.refreshRequirementsOnChange) {
      const updatedDetailsFields = {
        ...state.details,
        [fieldKey]: data
      };
      setIsActiveFormFetching(true);
      const updatedState = {
        ...state,
        details: updatedDetailsFields
      };
      try {
        const responseData = await getCurrentWiseRecipientDetails(state.currency, updatedState);
        const formFields = (responseData[state.recipientDetailsType]?.fields || []).map((field_0: WiseRecipientDetailsFieldInterface) => field_0.group?.[0]?.key).filter(Boolean);
        Object.keys(state.details).forEach(fieldKey_0 => {
          if (!formFields.includes(fieldKey_0)) delete updatedDetailsFields[fieldKey_0];
        });
        setFormData(responseData);
        updateFormDetails(updatedDetailsFields);
      } catch {} finally {
        setIsActiveFormFetching(false);
      }
    }
  };
  useEffect(() => {
    if (formData && formData[state.recipientDetailsType]) {
      setActiveForm(formData[state.recipientDetailsType] || undefined);
    }
  }, [formData, state.recipientDetailsType]);
  return <>
      {isTypeOfRecipientDetailsSelect && <FormSelect data={typeOfRecipientDetailsSelectData} label={t('dashboard.user_settings.affiliate_commissions.wire_table.recipient_type_title')} placeholder={t('dashboard.user_settings.affiliate_commissions.wire_table.recipient_type_placeholder')} value={activeForm?.type} onChange={data_0 => {
      const updatedRecipientDetailsItem = formData ? Object.values(formData).find(item_0 => item_0?.type === data_0) : undefined;
      if (updatedRecipientDetailsItem && formData) {
        onChangeRecipientDetailsType(updatedRecipientDetailsItem?.type || '');
        setActiveForm(updatedRecipientDetailsItem || undefined);
      }
    }} withoutCloseIcon required />}
      {activeForm?.fields.map(field_1 => getFormField(field_1, onChangeDetails, handleFormSelectChange, state, fieldErrors || {}, isActiveFormFetching))}
    </>;
}
export function getFormField(field: WiseRecipientDetailsFieldInterface, onChange: (key: string, value: string) => void, onChangeDetailsWithFormUpdate: (field: WiseRecipientDetailsFieldInterface, data: string) => Promise<void>, state: WiseRecipientApiInterface, fieldErrors: ErrorResponseContentInterface['fields'], isActiveFormFetching: boolean) {
  const fieldGroup = field.group?.[0];
  if (!fieldGroup) return null;
  switch (fieldGroup.type) {
    case WiseRecipientFormFieldTypesEnum.select:
    case WiseRecipientFormFieldTypesEnum.radio:
      return <FormSelect data={fieldGroup.valuesAllowed?.map(el => {
        return {
          ...el,
          id: el.key,
          caption: el.name
        };
      }) || []} label={fieldGroup.name} value={state.details?.[fieldGroup.key] as string | undefined || ''} onChange={data => {
        if (data) {
          onChangeDetailsWithFormUpdate(field, data);
        }
      }} withoutCloseIcon required={fieldGroup.required} error={(fieldErrors?.[fieldGroup.key] || []).join('')} disabled={isActiveFormFetching} key={fieldGroup.key} />;
    case WiseRecipientFormFieldTypesEnum.date:
    case WiseRecipientFormFieldTypesEnum.text:
      return <FormInput value={state.details?.[fieldGroup.key] as string | undefined || ''} label={fieldGroup.name} onChange={e => onChange(fieldGroup.key, e.target.value)} required={fieldGroup.required} error={(fieldErrors?.[fieldGroup.key] || []).join('')} disabled={isActiveFormFetching} key={fieldGroup.key} />;
    default:
      return null;
  }
}